module.exports = __webpack_public_path__ + "img/img2.ac5f9ab3.svg";